import React from 'react';

import PropTypes from 'prop-types';
import { PrefillProgressBar } from 'ctm-components/components/anon_prefill/prefill_progress_bar';

export const CarProgressBar = ({ percentageComplete }) => {
    return (
        <PrefillProgressBar
            buckets={['Car', 'Cover', 'Address', 'Drivers', 'Results']}
            percentageComplete={percentageComplete} />
    );
};

CarProgressBar.propTypes = {
    percentageComplete: PropTypes.number.isRequired
};
